<footer>
  <div class="footer-navigation">
    <div class="container">
      <h1 class="visually-hidden">Footer</h1>
      <div class="footer-navigation-container">
        @let appStoreButton = appNavigation().appStoreButton;
        @let googlePlayButton = appNavigation().googlePlayButton;

        @if (appStoreButton && googlePlayButton) {
          <div class="footer-apps">
            <h2 class="footer-apps__header">{{ appNavigation().title }}</h2>

            @if (appStoreButton && googlePlayButton) {
              <wl-app-store-buttons
                [appStoreButtonLink]="appStoreButton"
                [googlePlayButtonLink]="googlePlayButton"
              />
            }
          </div>
        }
        <div class="footer-navigation__desktop">
          @for (nav of webNavigation(); track nav.title) {
            <div class="footer-navigation__desktop-row">
              <h2
                class="footer-navigation-details-title"
                id="footer-nav-{{ $index }}"
              >
                {{ nav.title }}
              </h2>
              <nav [attr.aria-labelledby]="'footer-nav-' + $index">
                <ul class="footer-navigation-list">
                  @for (item of nav.items; track item.url) {
                    <li>
                      <wl-nav-link
                        [linkTitle]="item.title"
                        [linkUrl]="item.url"
                      />
                    </li>
                  }
                </ul>
              </nav>
            </div>
          }
        </div>
        <div class="footer-navigation__mobile">
          @for (nav of webNavigation(); track nav.title) {
            <details class="footer-navigation-details" name="footer-nav">
              <summary>
                <div class="footer-navigation-details-header">
                  <h2
                    class="footer-navigation-details-title"
                    id="footer-nav-details-{{ $index }}"
                  >
                    {{ nav.title }}
                  </h2>
                  <fa-icon
                    class="footer-navigation-details-icon"
                    icon="chevron-down"
                  />
                </div>
              </summary>
              <nav [attr.aria-labelledby]="'footer-nav-details-' + $index">
                <ul class="footer-navigation-list">
                  @for (item of nav.items; track item.url) {
                    <li>
                      <wl-nav-link
                        [linkTitle]="item.title"
                        [linkUrl]="item.url"
                      />
                    </li>
                  }
                </ul>
              </nav>
            </details>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="footer-useful-links">
    <div class="container">
      <nav aria-label="Handige links" class="footer-useful-links-legal">
        <ul class="footer-navigation-list footer-useful-links-legal-list">
          @for (link of usefulLinks(); track $index) {
            <li class="footer-useful-links-legal-link">
              <wl-nav-link
                [linkTitle]="link.title"
                [linkUrl]="link.url"
                theme="light"
                fullWidth
              />
            </li>
          }
        </ul>
      </nav>

      <div class="footer-useful-links-branding">
        <wl-navigation-logo
          variant="light"
          [label]="logo().label"
          [width]="logo().width"
          [height]="logo().height"
          [url]="this.logo().url"
        />
      </div>

      <div class="footer-useful-links-copyright">
        <small class="copyright"
          >&copy;{{ brandName() }} {{ currentYear() }}</small
        >
      </div>
    </div>
  </div>
</footer>
